import React from "react";
import { Heading, Icon, Text } from "@kaena1/mm-ui-components";
import "../css/profile-video-card.scss";

interface ProfileCardProps {
  name: string;
  title?: string;
  text: string;
  image: string;
  onClick: () => void;
}

export const ProfileVideoCard = ({
  name,
  title,
  text,
  image,
  onClick,
}: ProfileCardProps) => {
  return (
    <div className="profileCardContainer">
      <div className="imageWrapper" onClick={onClick}>
        <img 
          className="profileCardImage" 
          src={image} 
          alt={name}
        />
        <div className="imageGradient">
        <div className="playButtonIcon">
          <Icon fill="#FFF" height={64} width={64}>
             <img 
              src="/wp-content/themes/mintmobile/v3/assets/icons/reviews/playButton.svg" 
              alt="Play button"
            />
          </Icon>
        </div>
          <Heading className="profileCardName" as="h3">
            {name}
          </Heading>
          {title && (
            <Heading className="profileCardTitle" as="h3">
              {title}
            </Heading>
          )}
        </div>
      </div>
      <div className="profileCardTextContainer">
        <Text className="quoteSymbol">“</Text>
        <Text className="profileCardText">{text}</Text>
      </div>
    </div>
  );
};